import { CodeMappingsListItems } from '../types-store';

export const getCodeMappingId = (codeData: CodeMappingsListItems) =>
  `${codeData.codetable ? codeData.codetable.value : ''}_${codeData.id}_${codeData.description}`;

export const getGroupedResult = (key: string, groupedResult): string => groupedResult?.[key]?.[0].codetable?.description;

export const getCodetableId = (id: string) => parseInt(id, 10);
